import apiCall from './apiCall';
import Uploader from './uploader';
import getDisplayName from './getDisplayName';
import history from './history';
import Portal from './portal';
import numFormat from './numFormat';
import {ETC_IMG_URL, IMG_URL, IMG_PATH} from './imageUrl';
import MapUtils from './map';
import JsonNullToSpace from './jsonNullToSpace';
import phone from './phone';
import generateUUID from './generateUUID';
import format from './format';
import { getProductName, getMembershipName, getDmeMembershipName, getMembershipNameByType, getPayType, getColor, getStatusName, getProxyStatusName } from './type';
import paymentsUtil from './payments';

export {
  apiCall,
  Uploader,
  getDisplayName,
  history,
  Portal,
  numFormat,
  ETC_IMG_URL,
  IMG_URL,
  IMG_PATH,
  MapUtils,
  JsonNullToSpace,
  phone,
  generateUUID,
  format,
  getProductName,
  getStatusName,
  getProxyStatusName,
  getMembershipName,
  getDmeMembershipName,
  getPayType,
  getMembershipNameByType,
  getColor,
  paymentsUtil
};



// WEBPACK FOOTER //
// ./client/utils/index.js